import { useApp } from "@/context/AppContext";
import { toast } from "sonner";
import { RotateCcw, EyeOff } from "lucide-react";

/* Section wrapper — in admin edit-mode shows a Hide/Restore control.
   `sid` is the stable edit id (distinct from the HTML anchor `id`, which
   flows through `...rest`). Hidden state is persisted as override `sec.<sid>`. */
export function Section({ sid, name, className = "", children, ...rest }) {
  const { editMode, ov, saveText, resetOverride } = useApp();
  const key = `sec.${sid}`;
  const hidden = ov(key) === "1";

  if (!editMode && hidden) return null;

  const hide = async () => {
    try { await saveText(key, "1"); toast.success("Section hidden from visitors"); }
    catch { toast.error("Failed to hide section"); }
  };
  const restore = async () => {
    try { await resetOverride(key); toast.success("Section restored"); }
    catch { toast.error("Failed to restore section"); }
  };

  return (
    <section
      className={`${className} ${editMode ? "oj-sec-wrap" : ""} ${editMode && hidden ? "oj-sec-dim" : ""}`}
      data-section-id={sid}
      {...rest}
    >
      {editMode && (
        <div className="oj-sec-bar" contentEditable={false}>
          <span className="oj-sec-tag">{name || sid}</span>
          {hidden ? (
            <button type="button" onClick={restore} className="oj-sec-act oj-sec-restore" data-testid={`sec-restore-${sid}`}>
              <RotateCcw className="w-3.5 h-3.5" /> Restore
            </button>
          ) : (
            <button type="button" onClick={hide} className="oj-sec-act oj-sec-del" data-testid={`sec-hide-${sid}`}>
              <EyeOff className="w-3.5 h-3.5" /> Hide
            </button>
          )}
        </div>
      )}
      {children}
    </section>
  );
}

export default Section;
